const VerbConstants = (function () {
    const Verbs = (function () {
        var eventVerbs = [
            {
                symbol: "^",
                verbs: ["Realizing", "Reading", "Practising"],
                target: "Mind",
            },
            {
                symbol: "+",
                verbs: ["Achieving", "Building", "Completing"],
                target: "Achievement",
            },
            {
                symbol: "*",
                verbs: ["Discovering", "Browsing", "Creating", "Exploring"],
                target: "Creativity",
            },
            { symbol: "#", verbs: ["Enjoying", "Resting"], target: "Pleasure" },
            {
                symbol: "<",
                verbs: ["Trading", "Buying", "Receiving", "Investing"],
                target: "Material",
            },
            {
                symbol: ">",
                verbs: ["Connecting", "Socializing"],
                target: "Connection",
            },
            {
                symbol: "/",
                verbs: ["Stabilizing", "Rushing"],
                target: "Stability",
            },
            { symbol: "\\", verbs: ["Randomizing"], target: "Spontaneity" },
            {
                symbol: "_",
                verbs: ["Surviving", "Enduring", "Failing"],
                target: "Body",
            },
            { symbol: ".", verbs: ["Reaching"], target: "" },
        ];

        const inactiveVerbs = [
            "Creating",
            "Completing",
            "Exploring",
            "Resting",
            "Socializing",
            "Rushing",
            "Enduring",
        ];

        const All = () => eventVerbs;

        var Active = () =>
            Get().filter((verb) => !inactiveVerbs.includes(verb));

        var Get = (symbol?: string): string[] => {
            if (!symbol) {
                const allVerbs: string[] = eventVerbs
                    .map((eventVerb) => eventVerb.verbs)
                    .reduce(function (a, b) {
                        return a.concat(b);
                    })
                    .sort((a: string, b: string) => (a > b ? 1 : -1));

                return allVerbs;
            }

            var result = eventVerbs.find((verbs) => verbs.symbol === symbol)!
                .verbs;

            return result;
        };

        return {
            All,
            Active,
            Get,
        };
    })();

    var GetSymbol = (verb: string) => {
        if (!verb) throw new Error("Verb not provided!");
        var result = Verbs.All().find((row) => row.verbs.indexOf(verb) !== -1);
        if (!result) throw new Error("Cannot find symbol for the verb " + verb);
        return result.symbol;
    };

    var LookupData: {
        [index: string]: {
            Columns: object;
            Rows?: object;
        };
    } = {
        Statistics: {
            Columns: { name: 0, value: 1 },

            Rows: {
                level: 0,
                title: 1,
                health: 2,
                balance: 3,
                vitals: 4,
                intHealth: 5,
                longHealth: 6,
                kipsEarned: 7,
                kipsSaved: 8,
                kipsLevelUp: 9,
                kipsToday: 10,
                progressPercent: 11,
                drive1: 19,
                drive2: 20,
                drive3: 21,
                drive4: 22,
                drive5: 23,
                drive6: 24,
            },
        },
        Links: {
            Columns: { symbol: 0, name: 1, url: 2 },
        },
    };

    var Lookup = (componentName: string) => {
        return {
            Columns: LookupData[componentName.toString()].Columns,
            Rows: LookupData[componentName.toString()].Rows,
        };
    };

    const GetTarget = (symbol: string) =>
        Verbs.All()
            .filter((verb) => verb.symbol === symbol)
            .map((verb) => verb.target)[0];

    return {
        Verbs,
        GetSymbol,
        Lookup,
        GetTarget,
    };
})();

export default VerbConstants;
